import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  spotifyButton: {
    height: '100%',
    width: 'auto!important',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '5px 10px',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '219.5px',
    overflow: 'hidden',
    color: 'var(--clr-mountainMeadow)',

    '& > span': {
      ...mixins.longText,
    },

    '&.viboButton': {
      '&:disabled': {
        backgroundColor: 'transparent',
        opacity: '0.3',
      },
    },

    '@media screen and (min-width: 1500px)': {
      padding: '6px 10px',
      fontSize: '16px',
      lineHeight: '20.85px',
    },
  },
}));

export default useStyles;
